import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import InvoiceView from "@/components/InvoiceView";

export default function InvoicePrint() {
  const { oid } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    Promise.all([api.get(`/orders/${oid}`), api.get("/admin/business-settings")])
      .then(([o, b]) => setData({ order: o.data, biz: b.data }))
      .catch(() => setData(false));
  }, [oid]);
  if (data === false) return <div style={{ padding: 40, fontFamily: "Arial" }}>Invoice not found.</div>;
  if (!data) return <div style={{ padding: 40, fontFamily: "Arial" }}>Loading invoice…</div>;
  return <InvoiceView order={data.order} biz={data.biz} autoPrint />;
}
